import React from 'react'
import { getAcademic,getAcademicTree } from '../../utils/ApiService';
//muiTreeView imports
import { makeStyles } from '@material-ui/core';
import TreeView from '@material-ui/lab/TreeView';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import TreeItem from '@material-ui/lab/TreeItem';
import { Box } from '@material-ui/core';
import PopOver from "../Modal/Modal";
import KenSnackBar from '../../components/KenSnackbar';
import Header from "../Header";
import Card from './components/card';
import TreeCard from './components/card2';

//sorting function for academic Program type === academic program
function compare( a, b ) {
    if ( a.RecordType < b.RecordType ){
      return -1;
    }
    if ( a.RecordType > b.RecordType ){
      return 1;
    }
    return 0;
}

//styling for mui TreeView
const useStyles = makeStyles({
    root: {
      flexGrow: 1,
      textAlign:"left"
    },
    item:{
        marginLeft:20,
        padding:8,
    },
});


export default function Index() {

    const classes = useStyles();
    const [programs,setPrograms] = React.useState();
    

    React.useEffect(()=>{
        const id = 0;
        getAcademicTree(id)
        .then((arr)=>{
            console.log("[Academic Programs] cdm arr",arr);
            //console.log("[Academic Programs] cdm arr type",typeof arr);
            if(Array.isArray(arr)){
                arr.forEach(item => {
                    item.id = 'root'
                })
                //console.log("array after addign id",arr);
                setPrograms(arr);
            }
        })
        .catch((err)=>{
            console.log("Err [academicProram] cdm",err);
        })
    },[]);

    

    

    return (
        <div>
            
            <Header showRetrieve={true} home={true}/>
            
            <Box mt={6}>
            {
                programs && programs.map((element) => {
                    return(
                        <TreeView
                            className={classes.root}
                            defaultCollapseIcon={<ExpandMoreIcon />}
                            defaultExpanded={['root']}
                            defaultExpandIcon={<ChevronRightIcon />}
                        >
                            <RenderTree nodes={element} />
                        </TreeView>
                    )
                })
            }   
            </Box>
        </div>
    )
}


const RenderTree = (props) => {
    const classes = useStyles();
    //console.log(props);
    const {nodes} = props;
    const [subArray,setSub] = React.useState();
    const [currentRow, setCurrentRow] = React.useState({});
    const [openSnackbar, setOpenSnackbar] = React.useState(false);
    const [snackbarSeverity, setSnackbarSeverity] = React.useState('success');
    const [snackbarMessage, setSnackbarMessage] = React.useState('');
    //For Modal Popup
    const [open, setOpen] = React.useState(false);
    
    React.useEffect(()=>{
        if(nodes.RecordType !=="Academic Program"){
            getAcademicTree(props.nodes.Id)
            .then(resp => {
                console.log("subArray",resp);
                if(Array.isArray(resp)){
                    resp.sort(compare);
                    setSub(resp);
                }
            })
        }
    },[])

    const handleOpen = (currentRow) => {
        //console.log("object",currentRow);
        // setProgramId(programId);
        // setProgramName(name);
        // setInstituteId(instId);
        setOpen(true);
   
        setCurrentRow(currentRow);
    };

    const handleClose = (event, reason, submitted) => {
        setOpen(false);
    };

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') return;
        setOpenSnackbar(false);
    };

    const handleSnackbarOpen = (severity, message) => {
        setOpenSnackbar(true);
        setSnackbarSeverity(severity);
        setSnackbarMessage(message);
    };

    if(nodes.RecordType !=="Academic Program"){
        return(
            <TreeItem key={nodes.Id} nodeId={nodes.Id} label={nodes.Name} className={classes.item}>
                { 
                    subArray ? subArray.map((node) => <RenderTree nodes={node}/>) 
                    :null
                }
            </TreeItem>
        )
    }else{
        
        return(
            <div>
            <Box pt={1} pb={1} display="flex" justifyContent="space-between" >

                <Card nodes={nodes} handleOpen={handleOpen}></Card>

            </Box>
            <PopOver
                handleOpen={handleOpen}
                handleClose={handleClose}
                open={open}
                // programID={programID}
                // programName={programName}
                // instituteId={instituteId}
                currentRow = {currentRow}
                handleSnackbarOpen={handleSnackbarOpen}
            />
            <KenSnackBar
                message={snackbarMessage}
                severity={snackbarSeverity}
                autoHideDuration={2000}
                open={openSnackbar}
                handleSnackbarClose={handleSnackbarClose}
                position='Bottom-Right' />
            </div>
        )
    }
};
